/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const Bookmark: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="bookmark" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M963.3333333333331 1190H396.6666666666667C334.3333333333333 1190 283.9 1139 283.9 1076.6666666666667L283.3333333333333 170L680 340L1076.6666666666665 170V1076.6666666666667C1076.6666666666665 1139 1025.6666666666667 1190 963.3333333333331 1190zM963.3333333333331 340L680 463.5333333333333L396.6666666666667 340V1076.6666666666667H963.3333333333331V340z" : "M770.6666666666667 952H317.3333333333334C267.4666666666667 952 227.12 911.2 227.12 861.3333333333333L226.6666666666667 136L544 272L861.3333333333334 136V861.3333333333333C861.3333333333334 911.2 820.5333333333334 952 770.6666666666667 952zM770.6666666666667 272L544 370.8266666666666L317.3333333333334 272V861.3333333333333H770.6666666666667V272z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
Bookmark.displayName = `Blueprint5.Icon.Bookmark`;
export default Bookmark;
